import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeeprootsLogsService } from '../../services/deeproots-logs.service';
import { DeeprootsFeedback } from '../../models/deeproots-log';
import { takeUntil } from 'rxjs';
import { PageSizeComponent } from '../../../../../shared/components/page-size/page-size.component';
import { PaginationComponent } from '../../../../../shared/components/pagination/pagination.component';
import { MenuComponentBase } from '../../../../../shared/base-classes/menu-component-base';
import { FilterComponent } from '../../../../../shared/components/filter/filter.component';
import { PopupComponent } from '../../../../../shared/components/popup/popup.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-deeproots-feedback',
  standalone: true,
  imports: [
    CommonModule,
    PageSizeComponent,
    PaginationComponent,
    FilterComponent,
    PopupComponent,
  ],
  templateUrl: './deeproots-feedback.component.html',
  styleUrl: './deeproots-feedback.component.scss',
})
export class DeeprootsFeedbackComponent
  extends MenuComponentBase
  implements OnInit
{
  deeprootsLogsService = inject(DeeprootsLogsService);
  router = inject(Router);

  loading = true;
  feedbacks: DeeprootsFeedback[] = [];
  currentPage = 1;
  pageSize = 50;
  totalFeedbacks = 0;
  sortBy = '';
  selectedFeedback: DeeprootsFeedback | null = null;
  showPopup = false;

  sortByOptions = [
    { option: 'Newest', value: 'newest' },
    { option: 'Highest Rating', value: 'highest' },
    { option: 'Lowest Rating', value: 'lowest' },
  ];

  override ngOnInit(): void {
    super.ngOnInit();
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.sortBy = params['sort'] || 'newest';
        this.loadFeedbacks(this.currentPage, this.pageSize);
      });
  }

  loadFeedbacks(page: number, pageSize: number): void {
    this.loading = true;
    this.deeprootsLogsService
      .getDeeprootsFeedbacks(page, pageSize, this.sortBy)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.feedbacks = res.results;
          this.totalFeedbacks = res.count;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.loadFeedbacks(this.currentPage, this.pageSize);
  }

  onPageSizeChange(newPageSize: number): void {
    this.pageSize = newPageSize;
    this.currentPage = 1;
    this.loadFeedbacks(this.currentPage, this.pageSize);
  }

  onSortByChange(sortBy: string): void {
    this.currentPage = 1;
    this.router.navigate([], {
      queryParams: { sort: sortBy },
      queryParamsHandling: 'merge',
    });
  }

  getRatingStars(rating: number): string {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  onCardClick(feedback: DeeprootsFeedback): void {
    this.selectedFeedback = feedback;
    this.showPopup = true;
  }

  closePopup(): void {
    this.showPopup = false;
    this.selectedFeedback = null;
  }
}
